import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { NetworkLoaderService } from '@services';

import { finalize, Observable } from 'rxjs';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {

    constructor(private networkLoaderService: NetworkLoaderService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        this.networkLoaderService.show();
        const credentialRequest = request.clone({ withCredentials: true });
        return next.handle(credentialRequest).pipe(
            finalize(() => {
                this.networkLoaderService.hide();
            })
        );
    }
}
